export default __webpack_public_path__ + "static/media/2.b9f45597.webp";